import { Chip } from "@mui/material";

export type BadgeTone = "success" | "error" | "warning" | "info" | "pending" | "muted";

const TONES: Record<BadgeTone | "neutral", { bgcolor: string; color: string }> = {
  success: { bgcolor: "#ECFDF3", color: "#027A48" },
  error: { bgcolor: "#FEF3F2", color: "#B42318" },
  warning: { bgcolor: "#FFFAEB", color: "#B54708" },
  info: { bgcolor: "#EFF8FF", color: "#175CD3" },
  pending: { bgcolor: "#FFF6ED", color: "#C4320A" },
  muted: { bgcolor: "#F2F4F7", color: "#667085" },
  neutral: { bgcolor: "#F9FAFB", color: "#344054" },
};

interface StatusBadgeProps {
  status?: string;
  // Known statuses; anything else renders neutral with its raw value.
  tones: Record<string, BadgeTone>;
  labels?: Record<string, string>;
}

const StatusBadge = ({ status, tones, labels }: StatusBadgeProps) => {
  const key = status || "";
  const tone = TONES[tones[key] || "neutral"];
  const label = labels?.[key] || key.replace(/_/g, " ") || "unknown";

  return (
    <Chip
      size="small"
      label={label}
      sx={{
        ...tone,
        height: 22,
        fontSize: 12,
        fontWeight: 600,
        borderRadius: "6px",
        textTransform: "capitalize",
      }}
    />
  );
};

export default StatusBadge;
